import Form from 'element-ui/lib/form'
import RenderFormItem from './render-form-item'
import RenderFormGroup from './render-form-group'
import NestedForm from './form-nested'
import FormWrapper from './form-wrapper'

import { clone, hasProp } from 'vessel/utils'

export default {
  name: 'VsFormBuilder',
  components: {
    'render-form-item': RenderFormItem,
    'render-form-group': RenderFormGroup
  },
  props: {
    ...Form.props,
    items: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    columns: {
      type: [String, Number, Object],
      default: 2
    },
    gap: {
      type: [String, Object],
      default: 'sm'
    },
    nested: {
      type: Boolean,
      default: false
    },
    wrapSlot: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    model(newValue) {
      this.items.forEach(item => {
        let options = { id: item.$id, value: newValue[item.$id] }
        this.updateValue(options)
      })
    }
  },
  data() {
    return {
      value: clone(this.model) || {}
    }
  },
  render(h) {
    this.items.forEach(item => {
      if (this.model && hasProp(item.$prop, this.model)) {
        item.$default = this.model[item.$prop]
      } else {
        item.$default = null
      }
    })

    this.items.forEach(this.addDefaultValue)

    const formOptions = {
      props: Object.assign({}, this._props, {
        model: this.value
      }),
      class: 'form-grid',
      ref: 'formBuilder'
    }

    const formContent = this.items.map((item, index) => {
      const data = {
        props: {
          key: index,
          data: item,
          value: this.value,
          itemValue: this.value[item.$id],
          disabled: this.disabled
        },
        on: {
          updateValue: this.onUpdateValue
        }
      }

      if (item.$type === 'group') {
        return h('render-form-group', data)
      } else {
        return h('render-form-item', data)
      }
    })

    const formSlot = this.$slots.default
    const formData = []

    if (this.wrapSlot && formSlot) {
      const slotCol = h('vs-grid-col', { props: { span: this.columns } }, formSlot)
      formContent.push(slotCol)
    }

    const gridOpts = { props: { columns: this.columns, gap: this.gap } }
    const formGrid = h('vs-grid-row', gridOpts, formContent)

    formData.push(formGrid)

    if (!this.wrapSlot && formSlot) {
      formData.push(...formSlot)
    }

    return h(this.nested ? NestedForm : FormWrapper, formOptions, formData)
  },
  mounted() {
    this.$nextTick(() => {
      Object.keys(Form.methods).forEach((item) => {
        this[item] = this.$refs.formBuilder[item]
      })
    })
  },
  methods: {
    addDefaultValue(item) {
      if (!item.$id || this.value[item.$id] !== undefined)
        return

      let defaultValue

      if (item.$type === 'group') {
        defaultValue = item.$items.reduce((acc, cur) => {
          if (cur.$default && cur.$id)
            acc[cur.$id] = cur.$default

          return acc
        }, {})
      } else if (item.$default !== undefined) {
        defaultValue = item.$default
      }

      let options = { id: item.$id, value: defaultValue }

      defaultValue !== undefined && this.updateValue(options)
    },
    updateValue({ id, value }) {
      this.value = Object.assign({}, this.value, {
        [id]: value
      })
    },
    onUpdateValue(data) {
      this.updateValue(data)
      this.$emit('update', this.value)
    },
    getFormValue() {
      return clone(this.value)
    }
  }
}
